import { ApiPage } from "@/api/page";
import { ApiActual } from "@/api/article";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useHomeData = () => {
  const { data: home, isLoading: loadingHome } = useLocalizedQuery({
    queryKey: ["home"],
    queryFn: async lang => ApiPage.getHomePage(lang),
  });

  const { data: actual, isLoading: loadingActual } = useLocalizedQuery({
    queryKey: ["actual", 1],
    queryFn: async lang =>
      ApiActual.getActual(lang, {
        pageNumber: 1,
        pageSize: 12,
      }),
  });

  return { home, loadingHome, actual, loadingActual };
};
